/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/store/reducers/projects.reducer.js
 * File: projects.reducer.js
 * Created Date: Sunday, January 27th 2019, 7:08:58 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Feb 25 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import * as AppActions from 'client/app/store/actions'
import * as Actions from '../actions'
// import { combineReducers } from 'redux'

const initialProjectState = {
  typeDefLoading: false,
  loading: false
}

// const reducer = combineReducers({
//   projects: projectReducer
// })
// export default reducer

export default function projectReducer (state = initialProjectState, action) {
  switch (action.type) {
    case AppActions.GET_APP_DATA:
    case Actions.GET_PROJECT_DATA:
      return requestProjectsResolve(state, action)

    case AppActions.GET_APP_DATA_SUCCESS:
    case Actions.GET_PROJECT_DATA_SUCCESS:
      return reduceProjectResolve(state, action)

    case Actions.GET_PROJECT_DATA_FAILURE:
      return reduceProjectReject(state, action)

    default: return state
  }
}

function requestProjectsResolve (state, action) {
  return {
    ...state,
    loading: true
  }
}

function reduceProjectResolve (state, action = {}) {
  const definition = action.data.projects.projectDef || action.data.projectDef || {}
  // Note - Hack-y fix for component grid
  if (definition && definition.props) {
    definition.props.map(prop => {
      const type = prop.type
      if (!~type.indexOf('PROJECT_')) {
        prop.type = 'PROJECT_' + type
      }
      return prop
    })
  }
  return Object.assign({}, state, {
    definition: definition,
    projects: action.data.projects.projects || action.data.projects || [],
    loading: false,
    error: null
  })
}

function reduceProjectReject (state, action = {}) {
  return Object.assign({}, state, {
    error: {
      message: action.error.message,
      stack: action.error.stack
    },
    projects: null,
    definition: null,
    loading: false
  })
}
